import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {APP_ICON_PATH} from '../../../environments/environment';

@Component({
	selector: 'app-regisafe-suchergebnisse-subs',
	templateUrl: './regisafe-suchergebnisse-subs.component.html',
	styleUrls: ['./regisafe-suchergebnisse-subs.component.scss'],
})
export class RegisafeSuchergebnisseSubsComponent implements OnInit {

	@Input() data: any;
	@Output() firstSubStructure: EventEmitter<any> = new EventEmitter<any>();
	substructures: Array<any> = [];
	appIconPath = APP_ICON_PATH;

	constructor() {
	}

	ngOnInit() {
		this.getSubStructuresFromData(this.data);
	}

	getSubStructuresFromData(data: object): Array<any> {
		Object.keys(data).forEach((key) => {
			if (key.startsWith('Sub')) {
				if (data[key] === true) {
					this.substructures.push(key.replace('Sub',''));
				}
			}
		});

		let firstSub = this.substructures[0];
		if (firstSub) {
			firstSub = firstSub.slice(3);
		} else {
			firstSub = '';
		}
		// eslint-disable-next-line no-underscore-dangle
		this.firstSubStructure.emit({objID: this.data._ObjID, firstSub});
		return this.substructures;
	}

}
